import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { handleRequest } from '../quipli-service-client';
import {
  DeliveryConfig,
  DeliveryOption,
  ProductDeliveryConfig,
  ShippingType,
  UpdateProductDeliveryConfigRequest,
} from './delivery';
import { OrderType } from '../order/order';

export const useDeliveryApi = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function getDeliveryConfiguration() {
    const config = {
      method: 'get',
      url: `${contextPath}quipli-service/v1/delivery/config`,
      headers: {
        'X-Tenant': tenant,
      },
    };
    return await handleRequest<DeliveryConfig>(config);
  }

  async function updateDeliveryConfiguration(deliveryConf: DeliveryConfig) {
    const config = {
      method: 'put',
      url: `${contextPath}quipli-service/v1/delivery/config`,
      headers: {
        'X-Tenant': tenant,
      },
      data: deliveryConf,
    };
    return await handleRequest<DeliveryConfig>(config);
  }

  async function getProductDeliveryConfig(productId: number): Promise<ProductDeliveryConfig> {
    const config = {
      method: 'get',
      url: `${contextPath}quipli-service/yorent/v1/products/${productId}/deliveryConfig`,
      headers: {
        'X-Tenant': tenant,
      },
    };
    return await handleRequest<ProductDeliveryConfig>(config);
  }

  async function updateProductDeliveryConfiguration(
    request: UpdateProductDeliveryConfigRequest,
  ): Promise<ProductDeliveryConfig> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/yorent/v1/products/${request.productId}/deliveryConfig`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };
    return await handleRequest<ProductDeliveryConfig>(config);
  }

  async function getDeliveryOptions(
    productTypes: { type: OrderType; id: number }[],
    locationId: number,
    selectedOption: ShippingType = ShippingType.SelfPickUp,
  ): Promise<DeliveryOption[]> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/delivery/getOptions`,
      headers: {
        'X-Tenant': tenant,
      },
      data: {
        productTypes,
        locationId,
        selectedOption,
      },
    };
    return await handleRequest<DeliveryOption[]>(config);
  }

  return {
    getDeliveryConfiguration,
    updateDeliveryConfiguration,
    getProductDeliveryConfig,
    updateProductDeliveryConfiguration,
    getDeliveryOptions,
  };
};
